import React from 'react';
import { useCustomerType } from '../context/CustomerTypeContext';
import { useCart } from '../context/CartContext';
import Logo from './Logo';
import './CustomerTypeSelection.css';

const CustomerTypeSelection = () => {
  const { selectCustomerType } = useCustomerType();
  const { clearCart } = useCart();

  const handleSelectType = (type) => {
    if (type === 'corporate') {
      clearCart();
    }
    selectCustomerType(type);
  };

  return (
    <div className="customer-type-selection">
      <div className="selection-overlay">
        <div className="selection-container">
          <div className="selection-glow selection-glow-left"></div>
          <div className="selection-glow selection-glow-right"></div>
          <div className="selection-header">
            <div className="logo-container">
              <Logo size="large" useImage={true} imageSrc="/logo.png" />
            </div>
            <h1>Welcome to MunchUps</h1>
          </div>

          <div className="selection-options">
            <div
              className="option-card private-option"
              onClick={() => handleSelectType('private')}
              role="button"
              tabIndex={0}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  handleSelectType('private');
                }
              }}
            >
              <div className="option-card-top">
                <div className="option-icon">👤</div>
              </div>
              <button className="btn btn-primary">Continue as Private Customer</button>
            </div>

            <div
              className="option-card corporate-option"
              onClick={() => handleSelectType('corporate')}
              role="button"
              tabIndex={0}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  handleSelectType('corporate');
                }
              }}
            >
              <div className="option-card-top">
                <div className="option-icon">🏢</div>
              </div>
              <button className="btn btn-secondary">Continue as Corporate Customer</button>
            </div>
          </div>

          <p className="selection-footer-note">
            You can switch customer type later from the navigation bar if needed.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CustomerTypeSelection;